import { toggleShowLevel2Modifier } from '../toggle_show_level_2_modifier';
import { toggleShowLevel2 } from '../level_2/toggle_show_level_2';
import * as GAEvents from '../../google_analytics/navigation';

export const onLevelOneClick = ($nav, setCurrentNavLabel) => event => {
    const $link = $(event.target);
    const $subNav = $('+ .navigation-level-2', event.target);
    const $otherSubNavs = $nav.find('.navigation-level-2').not($subNav);

    if (!$link.is('a[href]')) {
        const currentNavLabel = $link.text().replace(/\n/g, '').trim();

        setCurrentNavLabel(currentNavLabel);
        toggleShowLevel2Modifier($nav, $subNav);
        toggleShowLevel2($otherSubNavs, false);
        toggleShowLevel2($subNav);
        GAEvents.openSecondLevel(currentNavLabel);
    }
};
